import * as R from "ramda";

export const MACHINE_ANALYSIS_TABLE_LABELS = {
  EQUIPO: "equipo",
  SAMPLE_DATE: "fecha muestra",
  STATE: "estado",
  SOOT: "soot",
  VISC: "visc",
  FE: "fe",
  SI: "si",
  AL: "al",
  CU: "cu",
  PB: "pb",
  CA: "ca",
  ZN: "zn",
  P: "p",
  MG: "mg",
  CR: "cr",
};

export const MACHINE_ANAYLYSIS_TABLE = {
  ROW_PROPS: [
    { label: MACHINE_ANALYSIS_TABLE_LABELS.EQUIPO, type: "string", idx: 2 },
    { label: "código", type: "string", idx: 0 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.SAMPLE_DATE, type: "date", idx: 5 },
    { label: "iso", type: "date", idx: 53 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.STATE, type: "string", idx: 54 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.FE, type: "number", idx: 12 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CR, type: "number", idx: 13 },
    { label: "ni", type: "number", idx: 15 },
    { label: "mo", type: "number", idx: 27 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.AL, type: "number", idx: 18 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.PB, type: "number", idx: 21 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CU, type: "number", idx: 16 },
    { label: "sn", type: "number", idx: 17 },
    { label: "ti", type: "number", idx: 37 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CA, type: "number", idx: 22 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.MG, type: "number", idx: 23 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.P, type: "number", idx: 36 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.ZN, type: "number", idx: 24 },
    { label: "ba", type: "number", idx: 20 },
    { label: "b", type: "number", idx: 28 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.SI, type: "number", idx: 14 },
    { label: "na", type: "number", idx: 19 },
    { label: "v", type: "number", idx: 38 },
    { label: "k", type: "number", idx: 29 },
    { label: "li", type: "number", idx: 34 },
    { label: "mn", type: "number", idx: 25 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.VISC, type: "number", idx: 30 },
    { label: "tbn", type: "number", idx: 32 },
    { label: "water", type: "number", idx: 44 },
    { label: "nitra", type: "number", idx: 41 },
    { label: "sulf", type: "number", idx: 42 },
    { label: "glyc", type: "number", idx: 45 },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.SOOT, type: "number", idx: 39 },
    { label: "diesel", type: "number", idx: 43 },
    { label: "infl", type: "number", idx: 31 },
    { label: "pq", type: "number", idx: 46 },
  ],
  getIndex(label: string | number): number {
    // @ts-ignore
    return R.findIndex(R.propEq("label", label))(this.ROW_PROPS);
  },
  MARKERS: {
    SOOT_LIMIT: {
      VALUE: 4,
      LABEL: "Límite Hollín",
    },
  },
};

export const SAMPLE_ANALYSIS_TABLE = {
  HEADERS: [
    { label: MACHINE_ANALYSIS_TABLE_LABELS.EQUIPO, key: "equipo_componente" },
    { label: "código", key: "id" },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.SAMPLE_DATE, key: "fecha_muestra" },
    { label: "iso", key: "iso" },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.STATE, key: "estado" },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.FE, key: "fe", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CR, key: "cr", customChart: true },
    { label: "ni", key: "ni", customChart: true },
    { label: "mo", key: "mo", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.AL, key: "al", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.PB, key: "pb", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CU, key: "cu", customChart: true },
    { label: "sn", key: "sn", customChart: true },
    { label: "ti", key: "ti", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.CA, key: "ca", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.MG, key: "mg", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.P, key: "p", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.ZN, key: "zn", customChart: true },
    { label: "ba", key: "ba", customChart: true },
    { label: "b", key: "b", customChart: true },
    { label: MACHINE_ANALYSIS_TABLE_LABELS.SI, key: "si", customChart: true },
    { label: "na", key: "na", customChart: true },
    { label: "v", key: "v", customChart: true },
    { label: "k", key: "k", customChart: true },
    { label: "li", key: "li", customChart: true },
    { label: "mn", key: "mn", customChart: true },
    {
      label: MACHINE_ANALYSIS_TABLE_LABELS.VISC,
      key: "visc",
      customChart: true,
    },
    { label: "tbn", key: "tbn", customChart: true },
    { label: "water", key: "water", customChart: true },
    { label: "nitra", key: "nitra", customChart: true },
    { label: "sulf", key: "sulf", customChart: true },
    { label: "glyc", key: "glyc", customChart: true },
    {
      label: MACHINE_ANALYSIS_TABLE_LABELS.SOOT,
      key: "soot",
      customChart: true,
    },
    { label: "diesel", key: "diesel", customChart: true },
    { label: "infl", key: "infl", customChart: true },
    { label: "pq", key: "pq", customChart: true },
  ],
};
